'use client';

import React from 'react';
import { Tooltip } from '@/components/ui-components/Tooltip/Tooltip';
import { InfoTooltipIcon } from '@/components/icons/InfoTooltipIcon';

export interface InfoTooltipProps {
  text: string;
  size?: number;
  color?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  theme?: 'light' | 'dark';
  style?: React.CSSProperties;
}

/**
 * InfoTooltip Component
 * 
 * A reusable component that combines an info icon with a tooltip.
 * Commonly used to provide contextual help text next to form labels.
 * 
 * @component
 * @example
 * ```tsx
 * <InfoTooltip text="This field is required" />
 * <InfoTooltip text="Custom help text" size={20} color="#666" />
 * ```
 */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({ 
  text,
  size = 16,
  color = '#000000',
  position = 'top',
  theme = 'light',
  style = { marginLeft: '6px' }
}) => (
  <Tooltip title={text} position={position} theme={theme}>
    <InfoTooltipIcon size={size} color={color} style={style} />
  </Tooltip>
);

export default InfoTooltip;
